"use client"
/* */
import { jsx } from 'react/jsx-runtime';
import 'react';
import styles from './ActionGroup.module.scss.mjs';
import '../../lib/propsContext/propsContext.mjs';
import '../../lib/viewComponentContext/viewComponentContext.mjs';
import { dynamic } from '../../lib/propsContext/dynamicProps/dynamic.mjs';
import { PropsContextProvider } from '../../lib/propsContext/PropsContextProvider.mjs';
import clsx from 'clsx';
import { flowComponent } from '../../lib/componentFactory/flowComponent.mjs';
import { TunnelProvider } from '@mittwald/react-tunnel';
import { ActionStateContextProvider } from '../Action/models/ActionStateContext.mjs';
import { getActionGroupSlot } from './lib/getActionGroupSlot.mjs';

const ActionGroup = flowComponent("ActionGroup", (props) => {
  const {
    children,
    className,
    ref,
    spacing = "s",
    ...rest
  } = props;
  const rootClassName = clsx(styles.actionGroup, className, styles[spacing]);
  const propsContext = {
    Button: {
      slot: dynamic((props2) => getActionGroupSlot(props2)),
      className: dynamic((props2) => {
        const slot = getActionGroupSlot(props2);
        return clsx(props2.className, styles[slot]);
      })
    },
    Switch: {
      labelPosition: "leading",
      className: dynamic((props2) => {
        return clsx(props2.className, props2.slot && styles[props2.slot]);
      })
    },
    Link: {
      className: dynamic((props2) => {
        return clsx(props2.className, props2.slot && styles[props2.slot]);
      })
    }
  };
  return /* @__PURE__ */ jsx(ActionStateContextProvider, { children: /* @__PURE__ */ jsx(PropsContextProvider, { props: propsContext, mergeInParentContext: true, children: /* @__PURE__ */ jsx(TunnelProvider, { children: /* @__PURE__ */ jsx("div", { ...rest, className: rootClassName, ref, role: "group", children }) }) }) });
});

export { ActionGroup, ActionGroup as default };
//# sourceMappingURL=ActionGroup.mjs.map
